import { Mail } from "lucide-react";
import { Reveal } from "./Motion";
import { useSettings } from "../../lib/settings";

const Profile = ({ img, pos, name, title, email, i, testid }) => (
  <Reveal delay={i * 0.12} className="group" >
    <article data-testid={testid}>
      <div className="relative aspect-[4/5] overflow-hidden border border-[rgba(212,175,55,0.35)] bg-[var(--ink-2)]">
        <img src={img} alt={`${name}, ${title} of Selby Asset Group`} loading="lazy"
          className="w-full h-full object-cover [filter:contrast(1.05)_brightness(1.02)_saturate(0.92)] transition-transform duration-[1.4s] ease-out group-hover:scale-[1.03]"
          style={{ objectPosition: pos }} />
        <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_50%_38%,transparent_45%,rgba(10,13,20,0.55)_100%)]" />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0a0d14]/85 to-transparent pointer-events-none" />
        <span className="absolute top-4 left-4 font-mono text-[0.65rem] uppercase tracking-[0.2em] bg-[#0a0d14]/80 backdrop-blur border border-[rgba(212,175,55,0.4)] text-gold px-3 py-1.5">{title}</span>
      </div>
      <div className="pt-6 border-b hairline pb-6">
        <h3 className="font-display text-3xl md:text-4xl text-slate-50" data-testid={`${testid}-name`}>{name}</h3>
        <p className="eyebrow mt-2">{title}, Selby Asset Group</p>
        <a href={`mailto:${email}`} className="inline-flex items-center gap-2 mt-4 text-sm text-slate-200 hover:text-gold transition-colors break-all" data-testid={`${testid}-email`}>
          <Mail className="w-4 h-4 text-gold shrink-0" /> {email}
        </a>
      </div>
    </article>
  </Reveal>
);

export const Leadership = () => {
  const s = useSettings();
  return (
    <section className="py-24 md:py-32 border-t hairline" data-testid="leadership-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <p className="eyebrow">Leadership</p>
          <h2 className="font-display text-5xl md:text-6xl mt-5 leading-[1]">The people <em className="text-gold">behind the search.</em></h2>
          <p className="text-slate-300 mt-6 leading-relaxed">Clients work directly with the company's leadership. Reach out to either of us with questions about a request or the sourcing process.</p>
        </Reveal>
        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-8 lg:gap-10">
          <Profile i={0} img="/img/team/owner-scott-w-selby.jpg?v=2" pos="50% 30%" name={s.owner_name} title="Owner" email={s.owner_email} testid="profile-owner" />
          <Profile i={1} img="/img/team/manager-thomas-abraham.jpg" pos="50% 30%" name={s.manager_name} title="Manager" email={s.manager_email} testid="profile-manager" />
        </div>
      </div>
    </section>
  );
};
